module.exports = function getResource(label, vars = []) {
    let resources = {
        recentActivityText: 'Recent Activity',
        viewAllActivityLink: 'View all activity',
        spendLabel: 'Spend',
        earnedLabel: 'Earned',
        spendText: 'Spend'
    };

    return resources[label];
};
